import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { MaterialPurchasePopup, } from './MaterialPurchaseTable';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import moment from 'moment';
import CommonServices from '../../../services/axiosServices/apiServices/CommonServices';
import { saveAs } from "file-saver";
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import { id } from 'date-fns/locale';
import { permission } from '../../../utils/enums/ValidationMessage';
import { decryptAES } from '../../../utils/Encryption';
import { Navigate } from 'react-router-dom';

export default class MaterialPurchase extends Component {

    constructor(props) {
        super(props)
        this.transactionStockServices = new TransactionStockServices();
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.commonServices = new CommonServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            urlId: 0,
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            open: false,
            rowData: [],
            colDefs: [],
            itemRowData: [],
            itemColdefs: [],
            paginationPageSize: 50,
            isSelectItemPopUp: false,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            selectedRowsForfirstPOListOfVendors: [],
            firstPIList: [],
            secondPIList: [],
            thirdPIList: [],
            purchaseObject: {
                idMaterialInward: 0,
                updateStatus: 0,
                prefix: "",
                inwardNo: '',
                inwardDate: moment(new Date().toISOString()).format('YYYY-MM-DD'),
                idGatepass: 0,
                idGeneralProduct: 0,
                accountHeadList: [],
                gatepassList: [],
                // idInwardType: 1,
                // inwardList: [
                //     {
                //         value: 1,
                //         label: 'INTRASTATE'
                //     },
                //     {
                //         value: 2,
                //         label: 'INTERSTATE'
                //     }
                // ],
                idType: 1,
                typeList: [
                    {
                        value: 1,
                        label: 'INTRASTATE'
                    },
                    {
                        value: 2,
                        label: 'INTERSTATE'
                    }
                ],
                idVendor: 0,
                modeOfPayment: "",
                modeOfDelivery: "",
                vendorList: [],
                idInwardFrom: 2,
                inwardFromList: [
                    {
                        value: 1,
                        label: 'MANUALLY'
                    },
                    {
                        value: 2,
                        label: 'FROM PURCHASE ORDER'
                    }
                ],
                paymentTerms: '',
                personName: '',
                vehicleNo: '',
                idInwardBy: 0,
                inwardbyList: [],
                address: '',
                invoiceNo: '',
                invoiceDate: '',
                invoiceFile: '',
                fileExtension: '',
                totalQuantity: "",
                totalAmt: "",
                extraCharges: "",
                totalDiscountAmt: "",
                taxAmt: "",
                totalwithTax: "",
                taxableAmt: "",
                adjustableAmt: "",
                totalTaxAmt: "",
                tcsPercentage: "",
                tcsAmt: "",
                totalDiffAmt: 0,
                potTotalAmt: 0,
                poTaxableAmt: 0,
                finalAmt: "",
                idFinancialYear: "",
                e_Date: "",
            },
            selectItemColDefs: [
                {
                    field: "itemCategory",
                    headerName: "Item Category",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemCategoryDesc",
                    headerName: "Item Category Desc",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "searchText",
                    headerName: "Search Text",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            productObject: {
                idPurchaseOrderItems: 0,
                idPurchaseOrder: 0,
                idMaterialPlanning: 0,
                idMaterialPlanningDetails: 0,
                keyId: 0,
                drawingNo: "",
                poQuantity: "",
                pendingQuantity: "",
                idMaterialType: 1,
                materialTypeList: [
                    {
                        value: 1,
                        label: 'RAW MATERIAL'
                    },
                    {
                        value: 2,
                        label: 'FINISHED GOODS'
                    },
                    {
                        value: 3,
                        label: 'SEMI FINISHED'
                    },
                    {
                        value: 4,
                        label: 'SCRAP MATERIAL'
                    }
                ],
                idItem: "",
                itemIdLabel: "",
                itemList: [],
                idUnit: "",
                unitList: [],
                quantity: "",
                poRate: "",
                rate: "",
                amount: "",
                discount: "",
                discountAmt: "",
                chargesAmt: "",
                total: 0,
                idTaxGroup: "",
                taxList: "",
                sgst: "",
                sgstAmount: "",
                cgst: "",
                cgstAmount: "",
                igst: "",
                igstAmount: "",
                netTotal: "",
                //startDate: "",
                //endDate: "",
                remarks: "",
                poAmount: 0,
                poTaxableAmt: "",
            },
            paymentDetails: {
                totalQuantity: "",
                totalAmt: "",
                extraCharges: "",
                disAmt: "",
                taxAmt: "",
                totalTaxAmt: "",
                tcsPercentage: "",
                tcsAmt: "",
                finalAmt: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForWork: {
                inwardDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "inward date"
                        ),
                    },
                ],
                idGatepass: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "gate pass"
                        ),
                    },
                ],
                idGeneralProduct: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "account head"
                        ),
                    },
                ],
            },
            validationRules: {
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                ],
                rate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                ],
                amount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],
                idTaxStructure: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "tax group"
                        ),
                    },
                ],
            },
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetFields();
        this.setState({ isModalOpen: true, itemRowData: [], open: false, firstPIList: [], secondPIList: [] }, () => {
            this.getPrefixSelectPrefix();
            this.getExtraGatePassSelectForPurchase();
            this.getAllDropdown();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.setState({ open: false })
        this.resetProductObject()
        this.getTransactionPurchaseInwardSelectbyId(event.data.idMaterialInward);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idMaterialInward);
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForWork = () => {
        const newValidState = isValidForm(
            this.state.purchaseObject,
            this.state.validationRulesForWork,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.productObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
        this.setState({ isModalOpen: false, });
        this.resetFields()
    };

    handleChangeForWork = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.purchaseObject;
        if (name === "isClose") {
            details.isClose = !details.isClose;
        } else {
            details[name] = value;
        }
        this.setState({ purchaseObject: details }, () => {
            if (name === 'tcsPercentage' || name === 'adjustableAmt') {
                this.finalCalculation();
            }
        });
    }
    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.productObject;
        details[name] = value;
        this.setState({ productObject: details }, () => {
            this.calculatePricing();
        });
    }
    handleChangeForPayment = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.paymentDetails;
        details[name] = value;
        this.setState({ paymentDetails: details }, () => {
            this.finalCalculation();
        });
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    }

    handleChangeForDropdown = (event, name) => {
        let details = this.state.purchaseObject;
        let value = event.value;
        details[name] = value;
        if (name === 'idGatepass') {
            details.idVendor = event.partyName;
        }
        this.setState({ purchaseObject: details }, () => {
            if (name === 'idGatepass' || name === 'idVendor') {
                this.getPartyAccountSelectbyID_withGatePass()
            }
            else if (name === 'idType') {
                this.calculatePricing()
                // this.POdisableControls()
            }
        });
    }

    // POdisableControls = () => {
    //     if (this.state.purchaseObject.idPoFrom === 1) {
    //         this.disableControls(false)
    //     } else if (this.state.purchaseObject.idPoFrom === 2) {
    //         this.disableControls(true)
    //     }
    // }

    // disableControls = (res) => {
    //     // txtDrawingNo.Enabled = cmbItemType.Enabled = cmbItem.Enabled = txtQty.Enabled = txtRate.Enabled =
    //     //     txtAmount.Enabled = txtDiscount.Enabled = txtChargesAmt.Enabled = txtNetTotal.Enabled =
    //     //     cmbTaxGroup.Enabled = txtNetTotal.Enabled = txtItemRemarks.Enabled =
    //     //     btnInsert.Enabled = btnClear.Enabled = btnDelete.Enabled = res;
    // }

    handleChangeForDropdownForProductObject = (event, name) => {
        let details = this.state.productObject;
        let value = event.value;
        details[name] = value;
        this.setState({ productObject: details }, () => {
            if (name === 'idMaterialType') {
                this.getMasterItemSelectbyItemTypeVendorwise()
            } else if (name === 'idItem') {
                this.getMasterItemSelectbyIDVendorwiseRate()
            } else if (name === 'idTaxGroup') {
                this.getTaxStructureSelectbyID()
            }
        });
    }

    onItemRowDataClicked = (event) => {
        const itemRowData = [...this.state.itemRowData];
        const clickedId = event.data.idPurchaseOrderItems;

        const getItemData = itemRowData.find(item => item.idPurchaseOrderItems === clickedId);
        if (!getItemData) return;

        const details = { ...this.state.productObject };

        details.idPurchaseOrderItems = getItemData.idPurchaseOrderItems;
        details.idPurchaseOrder = getItemData.idPurchaseOrder;
        details.idMaterialPlanning = getItemData.idMaterialPlanning;
        details.idMaterialPlanningDetails = getItemData.idMaterialPlanningDetails;
        details.drawingNo = getItemData.drawingNo;
        details.idMaterialType = getItemData.materialType ? this.state.productObject.materialTypeList.find(x => x.label === getItemData.materialType).value : 0;
        details.idItem = getItemData.idItem;
        details.itemIdLabel = getItemData.itemName;
        details.poQuantity = getItemData.poQuantity;
        details.pendingQuantity = getItemData.pendingQuantity;
        details.idUnit = getItemData.idUnit;
        details.quantity = getItemData.quantity;
        details.rate = getItemData.rate;
        details.poRate = getItemData.poRate;
        details.amount = getItemData.amount;
        details.discount = getItemData.discount;
        details.discountAmt = getItemData.discountAmt;
        details.chargesAmt = getItemData.chargesAmt;
        details.total = getItemData.total;
        details.idTaxGroup = getItemData.idTaxGroup;
        details.sgst = getItemData.sgst;
        details.sgstAmount = getItemData.sgstAmount;
        details.cgst = getItemData.cgst;
        details.cgstAmount = getItemData.cgstAmount;
        details.igst = getItemData.igst;
        details.igstAmount = getItemData.igstAmount;
        details.netTotal = getItemData.netTotal;
        details.poAmount = getItemData.poAmount;
        details.poTaxableAmt = getItemData.poTaxableAmt;
        details.remarks = getItemData.remarks;
        details.keyId = getItemData.keyId;
        details.idUnit = getItemData.idUnit

        this.setState({ productObject: details });
    };


    // deleteItem = (keyId) => {
    //     let data = this.state.purchaseObject;
    //     let idPurchaseOrderItems = this.state.itemRowData?.find(item => item.keyId == keyId)?.idPurchaseOrderItems;
    //     let filterData = this.state.itemRowData?.filter(item => item.keyId !== keyId);
    //     if (filterData.length > 0) {
    //         filterData.map((x, key) => {
    //             x.keyId = key + 1;
    //         });
    //     }
    //     //data.itemList = filterData;
    //     if (idPurchaseOrderItems > 0) {
    //         data.deleteItemsList.push(idPurchaseOrderItems);
    //     }
    //     this.setState({ purchaseObject: { ...data }, itemRowData: filterData }, () => {
    //         this.resetProductObject();
    //         this.finalCalculation();
    //     });
    // }

    handleDeleteItem = (keyId) => {
        let data = this.state.itemRowData.filter((x) => x.idPurchaseOrderItems != keyId);
        this.setState({ itemRowData: data }, () => {
            this.SwalServices.Success("Deleted sucessfully.");
            this.finalCalculation();
            this.resetProductObject();
        });
    };

    componentDidMount = () => {

        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0 }, () => {
                this.procSelectAllRecordsSP();
                this.getPrefixSelectPrefix();
                this.getExtraGatePassSelectForPurchase();
            }, () => {
                if (this.gridApi) {
                    this.gridApi.hideOverlay(); // Hide AG Grid's loading overlay
                }
            });
        } else {
            // window.location.href = "/Login";
        }
        setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100)
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Material Purchase",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: this.state.idUser,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    this.setPermissions(permissions);
                    if (data.length > 0) {
                        //debugger;
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key),
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            width: this.getPinnedWidth(key),
                            hide: ["idMaterialInward", "debitStatus", "isApprove", "idPartyAccount"].includes(key),
                            pinned: ["sR.No", "inwardNo", "gatePassNo", "inwardDate", "vendor"].includes(key) ? "left" : null,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.includes("inwardDate") || key.includes("invoiceDate")
                                ? (params) => {
                                    if (!params.value) return "";
                                    return moment(params.value).format("DD-MM-YYYY");
                                }
                                : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Material Purchase",
                            colName: colName
                        }, () => {
                            this.procSelectAllRecord2GridviewSP(id);
                            this.getAllDropdown();
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        if (this.gridApi) {
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            } else {
                if (this.gridApi) {
                    this.gridApi.hideOverlay();
                    this.gridApi.showNoRowsOverlay();
                }
                //this.getPrefixSelectPrefix();
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    openPopUpFromURLId = (id) => {
        let details = this.state.purchaseObject;
        details.idMaterialInward = id;
        this.setState({ purchaseObject: details }, () => {
            this.getTransactionPurchaseInwardSelectbyId(this.state.purchaseObject.idMaterialInward);
        });
    };

    getColumnWidth = (key) => {
        const colwidth = {
            "invoiceNo": window.innerWidth * 0.07,
            "invoiceDate": window.innerWidth * 0.08,
            "totalQty": window.innerWidth * 0.05,
            "totalAmt": window.innerWidth * 0.06,
            "extraCharges": window.innerWidth * 0.05,
            "discount": window.innerWidth * 0.05,
            "taxAmt": window.innerWidth * 0.06,
            "finalAmt": window.innerWidth * 0.05,
            "poNo": window.innerWidth * 0.05,
            "isApprove": window.innerWidth * 0.06,
            "approvalStatus": window.innerWidth * 0.08,
            "debitStatus": window.innerWidth * 0.08,
            "diffAmount": window.innerWidth * 0.06,
            "qcStatus": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }
    getPinnedWidth = (key) => {
        const pinnedWidths = {
            "sR.No": window.innerWidth * 0.05,
            "inwardNo": window.innerWidth * 0.06,
            "gatePassNo": window.innerWidth * 0.06,
            "inwardDate": window.innerWidth * 0.08,
            "vendor": window.innerWidth * 0.15,
        }
        return pinnedWidths[key];
    }

    procSelectAllRecord2GridviewSP = (id) => {
        //debugger;
        let request = {
            id: id,
            formname: "Material Purchase",
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        //debugger
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                //debugger
                if (response.statusCode == 200 && response.responseItem !== null) {
                    //debugger;
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1,
                            minWidth: this.table2ColWidth(key),
                            pinned: this.table2PinnedWidth(key) ? "left" : null,
                            width: this.table2ColWidth(key),
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    } else {
                        this.setState({
                            table2Data: [],
                            table2ColDefs: [],
                            isTable2Expanded: false
                        });
                    }
                }
            });
        }
    }

    table2ColWidth = (key) => {
        const colWidth = {
            "poNo": window.innerWidth * 0.05,
            "drawingNo": window.innerWidth * 0.1,
            "itemCategory": window.innerWidth * 0.15,
            "itemName": window.innerWidth * 0.15,
            "inwardQuantity": window.innerWidth * 0.06,
            "rate": window.innerWidth * 0.06,
            "taxableAmt": window.innerWidth * 0.06,
            "sgst": window.innerWidth * 0.05,
            "sgstAmt": window.innerWidth * 0.06,
            "cgst": window.innerWidth * 0.05,
            "cgstAmt": window.innerWidth * 0.06,
            "igst": window.innerWidth * 0.05,
            "igstAmt": window.innerWidth * 0.06,
            "netTotal": window.innerWidth * 0.08,
        }
        return colWidth[key];
    }
    table2PinnedWidth = (key) => {
        const pinnedWidths = {
            // "productName": window.innerWidth * 0.1,
            // "inwardQuantity": window.innerWidth * 0.1,
            // "rate": window.innerWidth * 0.08,
            // "taxableAmt": window.innerWidth * 0.08,
        }
        return pinnedWidths[key];
    }

    getPrefixSelectPrefix = () => {
        let request = {
            formname: "FrmTransactionPurchaseInward",
            idCompany: this.state.idCompany,
            idCompanyDivision: 0,
        };
        this.accountTransactionServices.getPrefixSelectPrefix(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0];
                let dt = this.state.purchaseObject
                if (data) {
                    dt.prefix = data.prefix;
                }
                this.setState({ purchaseObject: dt }, () => {
                    //this.getNoCount();
                });
            } else {
                //this.getNoCount();
            }
        });
    }

    getNoCount = () => {
        // this.accountTransactionServices.getInwardNoCount(request).then((response) => {
        //     if (response.statusCode == 200 && response.responseItem !== null) {
        //         let data = response.responseItem.responseContent;
        //debugger;
        let details = this.state.purchaseObject;
        let maxIdPaymentMake = this.state.rowData.length > 0
            ? this.state.rowData.length
            : 0;
        let inwardNo = String(maxIdPaymentMake + 1).padStart(3, '0');
        details.poNo = details.prefix + inwardNo;
        this.setState({ purchaseObject: details }, () => {
            //this.getNetworkConfiguration();
        })
        //     }
        // });
    }

    getAllDropdown = () => {
        let request = [this.state.idCompany, 0,];
        this.transactionStockServices.getAllDropdown(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let purchaseObject = this.state.purchaseObject;
                let productObject = this.state.productObject;
                purchaseObject.vendorList = allData.filter(item => item.source === 'Master_PartyAccount');
                productObject.unitList = allData.filter(item => item.source === 'Master_Unit');
                productObject.taxList = allData.filter(item => item.source === 'Master_TaxStructure');
                if (this.state.urlId === 0) {
                    purchaseObject.inwardNo = purchaseObject.prefix + '' + allData.filter(item => item.source === 'Transaction_PurchaseInwardCount')?.[0].value + 1;
                }
                this.setState({
                    purchaseObject: purchaseObject,
                    productObject: productObject
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    getExtraGatePassSelectForPurchase = () => {
        let request = [this.state.idCompany, this.state.purchaseObject.updateStatus, this.state.purchaseObject.idMaterialInward];
        this.transactionStockServices.getExtraGatePassSelectForPurchase(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let purchaseObject = this.state.purchaseObject;

                allData = allData.map((x) => ({
                    value: x.idGatePass,
                    label: x.gatePassNo + ' - ' + x.party,
                    partyName: x.partyName,
                    gatepassNo: x.gatePassNo
                }));
                purchaseObject.gatepassList = allData;
                this.setState({
                    purchaseObject: purchaseObject,
                    //productObject: productObject
                }, () => {
                    this.getMasterAccountHeadSelect();
                });
            } else {
                this.getMasterAccountHeadSelect();
            }
        });
    }

    getMasterAccountHeadSelect = () => {
        this.accountTransactionServices.usp_Master_GeneralProductSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let purchaseObject = this.state.purchaseObject;
                data = data.map((x) => ({
                    value: x.idGeneralProduct,
                    label: x.productName,
                }))
                    .filter((x) => x.label === 'PURCHASE');
                purchaseObject.accountHeadList = data;
                this.setState({ purchaseObject: purchaseObject });
            } else {
            }
        });
    }

    onFileChange = (event, identity) => {
        //debugger
        const file = event.target.files[0];
        // if (identity === "Upload_Certificate") {
        if (
            file &&
            (file.type === "image/jpeg" ||
                file.type === "image/png" ||
                file.type === "application/pdf" ||
                file.type === "application/pdf" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                file.type ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                file.type === "application/msword" ||
                file.type === "application/msexcel" ||
                file.type === "application/vnd.ms-excel")
        ) {
            let uploadFile = { ...this.state.resFile };
            uploadFile.filename = file.name;
            uploadFile["file"] = file;
            uploadFile.storagePath = identity;
            let detail = { ...this.state.partnerConsultantDetails };
            detail.brochureFilePath = file.name;
            // this.setState({ partnerConsultantDetails: detail },
            //   () => this.validateField("brochureFilePath")
            // );
            this.commonServices.uploadPDF(uploadFile).then((response) => {
                if (response != null && response.fileName != null) {
                    let detail = this.state.purchaseObject;
                    if (identity === 'MaterialPurchaseInvoiceFile') {
                        detail.invoiceFile = response.fileName;
                    }
                    this.setState({ purchaseObject: detail });
                    this.SwalServices.Success("Uploaded");
                }
                else {
                    this.SwalServices.Error(response.message);
                }
            })
        }
        else {
            this.SwalServices.Error("Please valid file!");
        }
        // }      
    };

    getFiles = (type, Filepath) => {
        if (Filepath) {
            let request = [
                // this.state.SLOTSApplicationDetails.slotsMemberId,
                type,
                Filepath,
            ];
            this.commonServices.getFiles(request).then((response) => {
                if (response.data !== null && response.status === 200) {
                    var formattedDate = moment(new Date()).format("DDMMYYYYHHmmss");
                    var filename = "";
                    filename = `${type}${formattedDate}`;
                    const extension = Filepath.split(".").pop();
                    if (extension) {
                        saveAs(new Blob([response.data]), `${filename}.${extension}`);
                    }
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        } else {
            this.SwalServices.Error("No data found");
        }
    };

    getPartyAccountSelectbyID_withGatePass = () => {
        if (this.state.purchaseObject.idVendor > 0) {
            let request = [this.state.purchaseObject.idVendor, this.state.purchaseObject.idGatepass];
            this.transactionStockServices.getPartyAccountSelectbyID_withGatePass(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    //debugger;
                    let data = this.state.purchaseObject;
                    //data.modeOfPayment = res.paymentTerms;
                    data.address = res.p_Address;
                    data.paymentTerms = res.paymentTerms;
                    data.email = res.emailID; //  data.inwardType?.find(item => item.name === res.invoiceType)?.id;
                    data.invoiceNo = res.invoiceNo;
                    data.invoiceDate = res.invoiceDate ? moment(res.invoiceDate).format('YYYY-MM-DD') : null;
                    this.setState({ materialInwardDetails: data }, () => {
                        this.getMasterItemSelectbyItemTypeVendorwise();
                    });
                }
            });
        }
    }

    getMasterItemSelectbyItemTypeVendorwise = () => {
        if (this.state.purchaseObject.idVendor > 0) {
            let request = [
                this.state.idCompany,
                this.state.productObject.materialTypeList?.find(x => x.value === this.state.productObject.idMaterialType)?.label,
                this.state.purchaseObject.idVendor
            ];
            this.transactionStockServices.getMasterItemSelectbyItemTypeVendorwise(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let allData = response.responseItem.responseContent;
                    let data = this.state.productObject;
                    data.itemList = allData;
                    this.setState({
                        productObject: data
                    });
                } else {
                    //this.usp_Master_EmployeeSelect()
                }
            });
        } else {
            this.SwalServices.Alert("Please Select Vendor First");
        }
    }

    getMasterItemSelectbyIDVendorwiseRate = () => {
        let request = [
            this.state.productObject.idItem,
            this.state.purchaseObject.idVendor
        ];
        this.transactionStockServices.getMasterItemSelectbyIDVendorwiseRate(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent[0];
                let data = this.state.productObject;
                data.drawingNo = allData.drawingNo;
                data.idMaterialType = data.materialTypeList.find(x => x.label === allData.itemType)?.value;  // chack please
                data.rate = allData.finalItemRate;
                //data.actualRate = allData.finalItemRate;
                data.idTaxGroup = allData.idTaxGroup;
                data.idUnit = allData.idUnit;
                //data.startDate = allData.startDate ? moment(allData.startDate).format('YYYY-MM-DD') : moment(new Date().toISOString()).format('YYYY-MM-DD');
                //data.endDate = allData.endDate ? moment(allData.endDate).format('YYYY-MM-DD') : moment(new Date().toISOString()).format('YYYY-MM-DD');

                this.setState({
                    productObject: data
                }, () => {
                    this.getTaxStructureSelectbyID();
                    //this.calcQtyRate();
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    getTaxStructureSelectbyID = () => {
        if (this.state.productObject.idTaxGroup > 0) {
            this.accountTransactionServices.getTaxStructureSelectbyID(this.state.productObject.idTaxGroup).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    //debugger;
                    let data = this.state.productObject;
                    data.sgst = res.sgst;
                    data.cgst = res.cgst;
                    data.igst = res.igst;
                    this.setState({ productObject: data }, () => {
                        this.calculatePricing();
                    });
                }
            });
        }
    }

    // calculatePricing = () => {
    //     if (this.state.productObject.rate && this.state.productObject.quantity) {
    //         let productObject = this.state.productObject;
    //         let purchaseObject = this.state.purchaseObject;
    //         var amt2 = 0;
    //         productObject.total = 0;
    //         productObject.sgstAmount = 0;
    //         productObject.cgstAmount = 0;
    //         productObject.igstAmount = 0;
    //         productObject.netTotal = 0;
    //         productObject.amount = 0
    //         productObject.discountAmt = 0;
    //         productObject.amount = Number(productObject.quantity) * Number(productObject.rate);
    //         //amt2 = Number(productObject.quantity) * Number(productObject.rate);
    //         productObject.total = Number(productObject.amount);
    //         productObject.discountAmt = (Number(productObject.amount) / 100) * Number(productObject.discount);
    //         productObject.total = productObject.total - productObject.discountAmt;
    //         productObject.total = productObject.total + Number(productObject.chargesAmt);
    //         productObject.sgstAmount = purchaseObject.idType === 1 ? (productObject.total * productObject.sgst) / 100 : 0;
    //         productObject.cgstAmount = purchaseObject.idType === 1 ? (productObject.total * productObject.cgst) / 100 : 0;
    //         productObject.igstAmount = Number(productObject.igst) > 0 ? purchaseObject.idType === 1 ? 0 : (productObject.total * productObject.igst) / 100 : 0;

    //         productObject.poAmount = Number(productObject.poTaxableAmt);
    //         productObject.poTaxableAmt = Number(productObject.poTaxableAmt);
    //         productObject.netTotal = productObject.total + productObject.sgstAmount + productObject.cgstAmount + productObject.igstAmount;
    //         this.setState({ productObject: productObject });
    //     }
    // }
    calculatePricing = () => {
        const { productObject, purchaseObject } = this.state;

        if (productObject.quantity !== null && productObject.rate !== null) {
            let amt = Number(productObject.quantity) * Number(productObject.rate);
            let amt2 = Number(productObject.quantity) * Number(productObject.poRate || 0);

            const discountPer = Number(productObject.discount || 0); // percentage
            let discountAmt = 0;

            if (discountPer > 0) {
                discountAmt = (amt * discountPer) / 100;  // ✅ actual discount value
                amt -= discountAmt;
                amt2 -= (amt2 * discountPer) / 100;
            }

            const chargesAmt = Number(productObject.chargesAmt || 0);
            amt += chargesAmt;
            amt2 += chargesAmt;

            let sgst = productObject.sgst || 0,
                cgst = productObject.cgst || 0,
                igst = productObject.igst || 0;

            const isIntraState = purchaseObject.idType === 1;
            const sgstAmt = isIntraState ? (amt * sgst) / 100 : 0;
            const cgstAmt = isIntraState ? (amt * cgst) / 100 : 0;
            const igstAmt = isIntraState ? 0 : (amt * igst) / 100;

            productObject.amount = Number(productObject.quantity) * Number(productObject.rate);
            productObject.discountAmt = discountAmt.toFixed(2); // ✅ store discountAmt
            productObject.total = amt;
            productObject.poAmount = Number(productObject.quantity) * Number(productObject.poRate || 0);;
            productObject.poTaxableAmt = amt2;
            productObject.sgstAmount = sgstAmt;
            productObject.cgstAmount = cgstAmt;
            productObject.igstAmount = igstAmt;
            productObject.netTotal = amt + sgstAmt + cgstAmt + igstAmt;

            productObject.taxLabels = {
                sgst: isIntraState ? `SGST-${sgst}%` : "0",
                cgst: isIntraState ? `CGST-${cgst}%` : "0",
                igst: isIntraState ? `IGST-${igst}%` : "0"
            };

            this.setState({ productObject });
        }
    };


    finalCalculation = () => {
        let data = this.state.itemRowData;
        let finalAmountCal = this.state.purchaseObject;

        finalAmountCal.totalQuantity = 0;
        finalAmountCal.totalAmt = 0;
        finalAmountCal.extraCharges = 0;
        finalAmountCal.totalDiscountAmt = 0;
        finalAmountCal.taxAmt = 0;
        finalAmountCal.totalwithTax = 0;
        finalAmountCal.tcsAmt = 0;
        finalAmountCal.totalTaxAmt = 0;
        finalAmountCal.finalAmt = 0;
        finalAmountCal.totalDiffAmt = 0;
        finalAmountCal.potTotalAmt = 0;
        finalAmountCal.poTaxableAmt = 0;
        finalAmountCal.taxableAmt = 0;

        data.map((x) => {
            let qty = Number(x.quantity) || 0;
            let rate = Number(x.rate) || 0;
            let amount = qty * rate;

            let discount = 0;
            if (x.discountPer) {
                discount = (amount * Number(x.discountPer)) / 100;
            } else if (x.discountAmt) {
                discount = Number(x.discountAmt);
            }

            finalAmountCal.totalQuantity += qty;
            finalAmountCal.totalAmt += Number(x.amount) || 0;
            finalAmountCal.extraCharges += Number(x.chargesAmt) || 0;
            finalAmountCal.totalDiscountAmt += discount;
            finalAmountCal.totalTaxAmt += (Number(x.sgstAmount) || 0) + (Number(x.cgstAmount) || 0) + (Number(x.igstAmount) || 0);
            finalAmountCal.finalAmt += Number(x.netTotal) || (amount - discount);
            finalAmountCal.potTotalAmt += Number(x.poAmount) || 0;
            finalAmountCal.poTaxableAmt += Number(x.poTaxableAmt) || 0;
            finalAmountCal.taxableAmt += Number(x.total) || (amount - discount);
        });

        finalAmountCal.totalwithTax = (
            (Number(finalAmountCal.totalAmt) - Number(finalAmountCal.totalDiscountAmt))
            + Number(finalAmountCal.extraCharges)
            + Number(finalAmountCal.totalTaxAmt)
        ).toFixed(2);

        finalAmountCal.potTotalAmt = Number(finalAmountCal.potTotalAmt).toFixed(2);
        finalAmountCal.poTaxableAmt = Number(finalAmountCal.poTaxableAmt).toFixed(2);

        finalAmountCal.tcsAmt = Number(finalAmountCal.tcsPercentage) > 0
            ? (Number(finalAmountCal.totalwithTax) * Number(finalAmountCal.tcsPercentage)) / 100
            : 0;

        finalAmountCal.finalAmt = Math.round(
            Number(finalAmountCal.totalwithTax) +
            Number(finalAmountCal.tcsAmt) +
            (Number(finalAmountCal.adjustableAmt) || 0)
        );

        finalAmountCal.totalDiffAmt = Number(finalAmountCal.totalAmt) - Number(finalAmountCal.potTotalAmt);
        finalAmountCal.taxableAmt = Number(finalAmountCal.taxableAmt).toFixed(2);
        finalAmountCal.totalAmt = Number(finalAmountCal.totalAmt).toFixed(2);
        finalAmountCal.extraCharges = Number(finalAmountCal.extraCharges).toFixed(2);
        finalAmountCal.totalDiscountAmt = Number(finalAmountCal.totalDiscountAmt).toFixed(2);
        finalAmountCal.totalTaxAmt = Number(finalAmountCal.totalTaxAmt).toFixed(2);
        finalAmountCal.tcsAmt = Number(finalAmountCal.tcsAmt).toFixed(2);

        this.setState({ purchaseObject: finalAmountCal });
    };

    insertItem = (flag) => {
        const details = { ...this.state.productObject };
        let itemList = [...this.state.itemRowData];

        // Assign a unique idPurchaseOrderItems if not already present (for Insert case)
        let newId = details.idPurchaseOrderItems || Date.now(); // or use itemList.length + 1

        const obj = {
            idPurchaseOrderItems: newId,
            idPurchaseOrder: details.idPurchaseOrder,
            idMaterialPlanning: details.idMaterialPlanning,
            idMaterialPlanningDetails: details.idMaterialPlanningDetails,
            drawingNo: details.drawingNo,
            idMaterialType: details.idMaterialType,
            materialType: details.materialTypeList?.find(x => x.value === details.idMaterialType)?.label || '',
            idItem: details.idItem,
            poQuantity: details.poQuantity,
            pendingQuantity: details.pendingQuantity,
            itemName: details.itemIdLabel,
            poRate: details.poRate,
            idUnit: details.idUnit,
            quantity: Number(details.quantity),
            rate: Number(details.rate),
            amount: Number(details.amount),
            discount: Number(details.discount),
            discountAmt: Number(details.discountAmt),
            chargesAmt: Number(details.chargesAmt),
            total: Number(details.total),
            idTaxGroup: details.idTaxGroup,
            sgst: details.sgst,
            sgstAmount: Number(details.sgstAmount),
            cgst: details.cgst,
            cgstAmount: Number(details.cgstAmount),
            igst: details.igstAmount > 0 ? details.igst : 0,
            igstAmount: Number(details.igstAmount),
            netTotal: Number(details.netTotal),
            poTaxableAmt: details.poTaxableAmt,
            poAmount: details.poAmount,
            remarks: details.remarks,
        };
        if (details.idItem !== 0) {
            if (flag === 'Insert') {
                itemList.push(obj);
            } else if (flag === 'Update') {
                const index = itemList.findIndex(
                    (x) => x.idPurchaseOrderItems === details.idPurchaseOrderItems
                );

                if (index !== -1) {
                    itemList[index] = obj;
                } else {
                    console.warn('Item not found for update.');
                    return;
                }
            }
        }

        this.setState({ itemRowData: itemList }, () => {
            this.resetProductObject();
            this.finalCalculation();
        });
    };



    resetProductObject = () => {
        let details = this.state.productObject;
        details.idPurchaseOrderItems = 0;
        details.idPurchaseOrder = 0;
        details.idMaterialPlanning = 0;
        details.idMaterialPlanningDetails = 0;
        details.drawingNo = "";
        details.idMaterialType = 1;
        details.idItem = 0;
        details.itemIdLabel = "";
        details.itemName = "";
        details.poQuantity = 0;
        details.pendingQuantity = 0;
        details.idUnit = 0;
        //details.unitDescription = "";
        details.quantity = "";
        details.rate = "";
        details.amount = "";
        details.discount = "";
        details.discountAmt = "";
        details.chargesAmt = "";
        details.total = "";
        //details.idTaxStructure = "";
        //details.taxStructureName = "";
        details.idTaxGroup = "";
        //details.taxGroup = "";
        details.sgst = "";
        details.sgstAmount = "";
        details.cgst = "";
        details.cgstAmount = "";
        details.igst = "";
        details.igstAmount = "";
        details.netTotal = "";
        details.poAmount = "";
        details.poTaxableAmt = "";
        details.remarks = "";
        details.keyId = "";
        this.setState({ productObject: details })
    }

    submit = () => {
        // guard against double-submit (rapid double-click / impatient re-click while the save is in flight)
        if (this.isSubmitting) {
            return;
        }
        const isValidAllFields = this.isValidAllFieldsForWork();
        if (isValidAllFields) {
            if (this.state.itemRowData.length === 0) {
                this.SwalServices.Alert("Please add items details");
            } else {
                let data = this.state.purchaseObject
                let productObject = this.state.productObject;
                let request = {
                    idMaterialInward: data.idMaterialInward,
                    updateStatus: data.updateStatus,
                    inwardNo: data.inwardNo,
                    inwardDate: (data.inwardDate && data.inwardDate !== 'Invalid date') ? data.inwardDate : null,
                    idPartyAccount: data.idVendor,
                    inwardType: data.typeList.find(x => x.value === data.idType)?.label,
                    inwardFrom: data.inwardFromList.find(x => x.value === data.idInwardFrom)?.label,
                    modeOfPayment: data.modeOfPayment,
                    modeOfDelivery: data.modeOfDelivery,
                    invoiceNo: data.invoiceNo,
                    invoiceDate: (data.invoiceDate && data.invoiceDate !== 'Invalid date') ? data.invoiceDate : null,
                    personName: data.personName,
                    gatePassNo: data.idGatepass > 0 ? data.gatepassList.find(x => x.value === data.idGatepass)?.gatepassNo : '',
                    fileName: data.invoiceFile,
                    fileExtension: data.fileExtension,
                    vehicleNo: data.vehicleNo,
                    inwardBy: data.idInwardBy,
                    totalQty: data.totalQuantity,
                    totalAmt: data.totalAmt,
                    taxAmt: data.totalTaxAmt,
                    totalTaxAmt: data.totalTaxAmt,
                    totalwithTax: data.totalwithTax,
                    extraCharges: data.extraCharges,
                    discount: data.totalDiscountAmt,
                    finalAmt: data.finalAmt,
                    remarks: "",
                    idCompany: this.state.idCompany,
                    e_Date: data.e_Date ? data.e_Date : new Date().toISOString(),
                    e_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                    isUpdated: data.updateStatus === 1 ? true : false,
                    updatedDate: data.updateStatus === 1 ? new Date().toISOString() : null,
                    u_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                    isDeleted: false,
                    deletedDate: null,
                    d_IDUser: null,
                    prefix: data.prefix,
                    idGatePass: data.idGatepass, // Required
                    diffAmount: data.totalDiffAmt,
                    totalPOAmt: data.potTotalAmt,
                    tcsAmt: data.tcsAmt,
                    tcsPercentage: data.tcsPercentage,
                    idFinancialYear: data.idFinancialYear,
                    idGeneralProduct: data.idGeneralProduct,
                    taxableAmt: data.taxableAmt,
                    adjustableAmt: data.adjustableAmt
                };
                //request.deleteItemsList = data.deleteItemsList;
                request.itemList = [];
                let itemList = this.state.itemRowData;
                //let details = this.state.productObject;
                itemList.map((details) => {
                    let obj = {
                        drawingNo: details.drawingNo,
                        itemType: productObject.materialTypeList.find(x => x.value === details.idMaterialType)?.label,
                        idItem: details.idItem,
                        poQuantity: details.poQuantity ? details.poQuantity : 0,
                        quantity: details.quantity ? details.quantity : 0,
                        pendingQty: details.pendingQuantity ? details.pendingQuantity : 0,
                        rate: details.poRate ? details.poRate : 0,
                        invoiceRate: details.rate ? details.rate : 0,
                        amount: details.amount,
                        poAmount: details.poAmount,
                        discount: details.discount,
                        extraCharges: details.chargesAmt,
                        taxableAmt: details.total,
                        poTaxableAmt: details.poTaxableAmt,
                        sgst: details.sgst,
                        sgstAmt: details.sgstAmount,
                        cgst: details.cgst,
                        cgstAmt: details.cgstAmount,
                        igst: details.igst,
                        igstAmt: details.igstAmount,
                        netTotal: details.netTotal,
                        idTaxGroup: details.idTaxGroup,
                        itemRemarks: details.remarks,
                        idPurchaseOrderItems: details.idPurchaseOrderItems,
                        idPurchaseOrder: details.idPurchaseOrder,
                        type: data.inwardFromList.find(x => x.value === data.idInwardFrom)?.label,
                        idMaterialPlanning: data.idMaterialPlanning,
                        idUnit: details.idUnit,
                        idMaterialPlanningDetails: data.idMaterialPlanningDetails,
                    }
                    request.itemList.push(obj);
                });
                this.isSubmitting = true;
                this.setState({ isSaving: true });
                this.transactionStockServices.submitPurchaseInwardInsertUpdate(request).then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let data = response.responseItem.responseContent;
                        if (data !== null) {
                            if (this.state.purchaseObject.updateStatus === 1) {
                                this.SwalServices.Success("Updated sucessfully.");
                            } else {
                                this.SwalServices.Success("Save sucessfully.");
                            }
                            if (this.state.urlId) {
                                this.setState({ route: '/ledger-report' });
                            } else {
                                this.setState({
                                    isModalOpen: false,
                                    //receiptDetails: reset
                                }, () => {
                                    this.resetFields();
                                    this.procSelectAllRecordsSP();
                                });
                            }
                        }
                    }
                }).finally(() => {
                    this.isSubmitting = false;
                    this.setState({ isSaving: false });
                });
            }
        }
    }

    resetFields = () => {
        let data = this.state.purchaseObject;
        data.idMaterialInward = 0;
        data.updateStatus = 0;
        //prefix: "",
        data.inwardNo = '';
        data.inwardDate = moment(new Date().toISOString()).format('YYYY-MM-DD');
        data.idGatepass = 0;
        data.poNo = '';
        data.prefix = '';
        data.poDate = moment(new Date().toISOString()).format('YYYY-MM-DD');
        data.idType = 1;
        data.modeOfPayment = '';
        data.idEmployee = 0;
        data.employeeList = [];
        data.idVendor = 0;
        data.vendorList = [];
        data.idPoFrom = 1;
        data.modeOfDelivery = '';
        data.paymentTerms = '';
        data.idAuthEmployee = 0;
        data.validity = '';
        data.address = '';
        data.deliveryDate = '';
        data.isClose = false;
        data.email = '';
        data.totalQuantity = "";
        data.totalAmt = "";
        data.extraCharges = "";
        data.totalDiscountAmt = "";
        data.taxAmt = "";
        data.totalTaxAmt = "";
        data.tcsPercentage = "";
        data.tcsAmt = "";
        data.finalAmt = "";
        data.idFinancialYear = "";
        data.e_Date = "";
        data.potTotalAmt = "";
        data.totalDiffAmt = "";
        data.taxableAmt = "";
        data.adjustableAmt = ""
        this.setState({ purchaseObject: data }, () => {
            this.resetProductObject();
        })
    }

    getTransactionPurchaseInwardSelectbyId = (idMaterialInward) => {
        if (idMaterialInward > 0) {
            this.transactionStockServices.getTransactionPurchaseInwardSelectbyId(idMaterialInward).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0][0];
                    let itemListRecords = response.responseItem.responseContent[1];
                    let itemList = [];
                    let purchaseObject = this.state.purchaseObject;
                    let productObject = this.state.productObject;
                    purchaseObject.idMaterialInward = res.idMaterialInward;
                    purchaseObject.updateStatus = 1;
                    purchaseObject.prefix = res.prefix ? res.prefix : '';
                    purchaseObject.inwardNo = res.inwardNo;
                    purchaseObject.inwardDate = moment(res.inwardDate).format('YYYY-MM-DD');
                    purchaseObject.idGatepass = res.idGatePass;
                    purchaseObject.idGeneralProduct = res.idGeneralProduct;
                    purchaseObject.idType = purchaseObject.typeList.find(x => x.label === res.inwardType)?.value;
                    //purchaseObject.typeList = [];
                    purchaseObject.idVendor = res.idPartyAccount;
                    purchaseObject.address = res.idPartyAccount > 0 ? this.state.purchaseObject.vendorList.find(x => x.value === res.idPartyAccount)?.name2 : '';
                    //purchaseObject.vendorList = [];
                    purchaseObject.modeOfPayment = res.modeOfPayment;
                    purchaseObject.modeOfDelivery = res.modeOfDelivery;
                    purchaseObject.idInwardFrom = purchaseObject.inwardFromList.find(x => x.label === res.inwardFrom)?.value;
                    //purchaseObject.inwardFromList = [];
                    purchaseObject.paymentTerms = res.modeOfPayment;
                    purchaseObject.personName = res.personName;
                    purchaseObject.vehicleNo = res.vehicleNo;
                    purchaseObject.idInwardBy = res.inwardBy;
                    //purchaseObject.inwardbyList = [];
                    //purchaseObject.address = res.address;
                    purchaseObject.invoiceNo = res.invoiceNo;
                    purchaseObject.invoiceDate = moment(res.invoiceDate).format('YYYY-MM-DD');
                    purchaseObject.invoiceFile = res.fileName;
                    purchaseObject.fileExtension = res.fileExtension;
                    purchaseObject.totalQuantity = res.totalQty;
                    purchaseObject.totalAmt = res.totalAmt;
                    purchaseObject.extraCharges = res.extraCharges;
                    //purchaseObject.totalDiscountAmt = res.totalDiscountAmt;
                    purchaseObject.totalDiscountAmt = res.discount;
                    purchaseObject.taxAmt = res.taxAmt;
                    purchaseObject.totalwithTax = res.totalwithTax;
                    purchaseObject.totalTaxAmt = res.taxAmt;
                    purchaseObject.tcsPercentage = res.tcsPercentage;
                    purchaseObject.tcsAmt = res.tcsAmt;
                    purchaseObject.totalDiffAmt = res.diffAmount;
                    purchaseObject.potTotalAmt = res.totalPOAmt;
                    purchaseObject.finalAmt = res.finalAmt;
                    purchaseObject.idFinancialYear = res.idFinancialYear;
                    purchaseObject.e_Date = res.e_Date;
                    purchaseObject.taxableAmt = res.taxableAmt;
                    purchaseObject.adjustableAmt = res.adjustableAmt;

                    itemListRecords.map((details, keyId) => {
                        let obj = {
                            idPurchaseOrderItems: details.idPurchaseOrderItems,
                            idPurchaseOrder: details.idPurchaseOrder,
                            idMaterialPlanning: details.idMaterialPlanning,
                            idMaterialPlanningDetails: details.idMaterialPlanning,
                            drawingNo: details.itemDrawingNo,
                            materialType: details.itemItemType,
                            idMaterialType: productObject.materialTypeList.find(x => x.label === details.itemItemType)?.value,
                            idItem: details.idItem,
                            itemName: details.itemName,
                            poQuantity: details.poQuantity,
                            pendingQuantity: details.pendingQty,
                            idUnit: details.idUnit,
                            //unitDescription : details. ,
                            quantity: details.inwardQuantity,

                            poRate: Number(details.rate).toFixed(2),
                            rate: Number(details.invoiceRate).toFixed(2),

                            amount: Number(details.amount),
                            discount: details.discount,

                            discountAmt: details.discount > 0 ? ((details.amount / 100) * Number(details.discount)).toFixed(2) : 0,

                            chargesAmt: Number(details.extraCharges).toFixed(2),
                            total: Number(details.taxableAmt).toFixed(2),

                            //idTaxStructure : details. ,
                            //taxStructureName : details. ,

                            idTaxGroup: details.idTaxGroup,

                            //taxGroup : details. ,
                            sgst: Number(details.sgst).toFixed(2),
                            sgstAmount: Number(details.sgstAmt).toFixed(2),

                            cgst: Number(details.cgst).toFixed(2),
                            cgstAmount: Number(details.cgstAmt).toFixed(2),

                            igst: Number(details.igst).toFixed(2),
                            igstAmount: Number(details.igstAmt).toFixed(2),

                            netTotal: Number(details.netTotal).toFixed(2),

                            poAmount: Number(details.poAmount).toFixed(2),
                            poTaxableAmt: Number(details.poTaxableAmt).toFixed(2),

                            remarks: details.itemRemarks,
                            keyId: keyId + 1,
                            idUnit: details.idUnit
                        }
                        itemList.push(obj);
                    })

                    this.setState({ purchaseObject: purchaseObject, itemRowData: itemList }, () => {
                        let req = [
                            this.state.idCompany,
                            itemListRecords[0]?.itemItemType,
                            res.idPartyAccount
                        ];
                        this.transactionStockServices.getMasterItemSelectbyItemTypeVendorwise(req).then((response2) => {
                            if (response2.statusCode == 200 && response2.responseItem !== null) {
                                let allData = response2.responseItem.responseContent;
                                //let data = this.state.productObject;
                                let itemRowData = this.state.itemRowData;
                                allData = allData.map((x) => ({
                                    value: x.idItem,
                                    label: x.itemName,
                                }));
                                //data.itemList = allData;
                                // this.setState({s
                                //     productObject: data
                                // }, () => {
                                //     let set = this.state.productObject;
                                itemRowData.map((y) => {
                                    y.itemName = y.itemName;
                                });
                                // this.setState({ itemRowData: [...itemList] });
                                // });
                            }
                            this.setState({ isModalOpen: true });
                            this.finalCalculation()
                            this.getExtraGatePassSelectForPurchase()
                        });
                    });
                }
            });
        }
    }


    addPO = () => {
        if (this.state.purchaseObject.idVendor > 0) {
            this.setState({ open: true }, () => {
                this.getTransaction_PurchaseOrderSelectbyIDVendor();
            })
        } else {
            this.SwalServices.Alert("Please Select Vendor First");
        }
    }

    handleCellClickSecondPIList = (event) => {
        this.getItemRateVendorwiseSelect3(event.data.idItem);
    };

    getTransaction_PurchaseOrderSelectbyIDVendor = () => {
        let request = [this.state.purchaseObject.idVendor, this.state.idCompany, this.state.purchaseObject.updateStatus, this.state.purchaseObject.idMaterialInward];
        this.transactionStockServices.getTransaction_PurchaseOrderSelectbyIDVendor(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                let data = this.state.firstPIList;
                let idPurchaseOrder = 0;
                data = [];
                if (res.length > 0) {
                    res.map((x) => {
                        x.Select = false;
                        x.deliveryDate = x.deliveryDate ? moment(x.deliveryDate).format("DD-MM-YYYY") : '';
                        x.poDate = x.poDate ? moment(x.poDate).format("DD-MM-YYYY") : '';
                    });
                    data = res;
                    idPurchaseOrder = res[0]?.idPurchaseOrder;
                }
                this.setState({ firstPIList: data }, () => {
                    if (idPurchaseOrder > 0) {
                        this.USP_Transaction_PurchaseOrderSelectbyID_PendingQty(idPurchaseOrder);
                    }
                });
            }
        });
    }

    handleCellClickfirstPIList = (event) => {
        // this.USP_Transaction_PurchaseOrderSelectbyID_PendingQty(event.data.idPurchaseOrder);
    };

    USP_Transaction_PurchaseOrderSelectbyID_PendingQty = (idPurchaseOrder) => {
        if (idPurchaseOrder > 0) {
            let request = [idPurchaseOrder, this.state.purchaseObject.idMaterialInward, this.state.purchaseObject.updateStatus];
            this.transactionStockServices.USP_Transaction_PurchaseOrderSelectbyID_PendingQty(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[1];
                    let data = [];
                    let idItem = 0;
                    if (res && res.length > 0) {
                        data = res;
                        idItem = res[0]?.idItem;
                    }
                    this.setState({ secondPIList: data });
                }
            });
        }
    }

    onSelectionChanged = (selectedRows) => {
        this.setState({ selectedRowsForfirstPOList: selectedRows }, async () => {
            const requests = selectedRows.map(element => {
                return this.USP_Transaction_PurchaseOrderSelectbyID_PendingQtyPromise(element.idPurchaseOrder);
            });

            const results = await Promise.all(requests);

            const mergedData = results.flat();
            this.setState({ secondPIList: mergedData });
        });
    }

    USP_Transaction_PurchaseOrderSelectbyID_PendingQtyPromise = (idPurchaseOrder) => {
        return new Promise((resolve) => {
            if (idPurchaseOrder > 0) {
                let request = [
                    idPurchaseOrder,
                    this.state.purchaseObject.updateStatus,
                    this.state.purchaseObject.idMaterialInward
                ];
                this.transactionStockServices.USP_Transaction_PurchaseOrderSelectbyID_PendingQty(request)
                    .then((response) => {
                        if (response.statusCode == 200 && response.responseItem !== null) {
                            let res = response.responseItem.responseContent[1];
                            if (res && res.length > 0) {
                                resolve(res); // Return the array
                            } else {
                                resolve([]); // Return empty array if no data
                            }
                        } else {
                            resolve([]); // Return empty array on error
                        }
                    });
            } else {
                resolve([]); // Invalid idPurchaseOrder
            }
        });
    };


    getItemRateVendorwiseSelect3 = (idItem) => {
        if (idItem > 0) {
            this.transactionStockServices.getItemRateVendorwiseSelect3(idItem).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent;
                    let data = [];
                    if (res.length > 0) {
                        data = res;
                    }
                    this.setState({ thirdPIList: data }, () => {
                    });
                }
            });
        }
    }

    // addProduct = async () => {
    //     let itemList = [...this.state.itemRowData];
    //     const selectedRows = this.state.selectedRowsForfirstPOList;
    //     const productMaterialTypeList = this.state.productObject.materialTypeList;

    //     for (const z of selectedRows) {
    //         let request = [
    //             z.idPurchaseOrder,
    //             this.state.purchaseObject.idMaterialInward,
    //             this.state.purchaseObject.updateStatus
    //         ];

    //         try {
    //             const response = await this.transactionStockServices.USP_Transaction_PurchaseOrderSelectbyID_PendingQty(request);

    //             if (response.statusCode === 200 && response.responseItem !== null) {
    //                 const res = response.responseItem.responseContent[1];

    //                 if (res.length > 0) {
    //                     for (const details of res) {
    //                         let obj = {
    //                             idPurchaseOrderItems: details.idPurchaseOrderItems,
    //                             idPurchaseOrder: details.idPurchaseOrder,
    //                             idMaterialPlanning: details.idMaterialPlanning || 0,
    //                             idMaterialPlanningDetails: details.idMaterialPlanningDetails || 0,
    //                             drawingNo: details.itemDrawingNo,
    //                             materialType: details.itemType,
    //                             idMaterialType: productMaterialTypeList.find(x => x.label === details.itemItemType)?.value,
    //                             idItem: details.idItem,
    //                             itemName: details.itemName,
    //                             poQuantity: details.quantity,
    //                             pendingQuantity: details.pendingQty,
    //                             quantity: details.recvQty,
    //                             poRate: details.rate,
    //                             rate: details.rate,
    //                             amount: details.amount,
    //                             discount: details.discount,
    //                             discountAmt: 0,
    //                             chargesAmt: details.extraCharges,
    //                             total: details.taxableAmt,
    //                             idTaxGroup: details.idTaxGroup,
    //                             sgst: details.sgst,
    //                             sgstAmount: details.sgstAmt,
    //                             cgst: details.cgst,
    //                             cgstAmount: details.cgstAmt,
    //                             igst: details.igstAmt > 0 ? details.igst : 0,
    //                             igstAmount: details.igstAmt,
    //                             netTotal: details.netTotal,
    //                             poAmount: details.amount,
    //                             poTaxableAmt: 0,
    //                             remarks: details.itemRemarks,
    //                         };
    //                         itemList.push(obj);
    //                     }
    //                 }
    //             }
    //         } catch (error) {
    //             console.error("Error fetching pending PO items:", error);
    //         }
    //     }

    //     this.setState({ itemRowData: itemList, open: false }, () => {
    //         this.finalCalculation();
    //     });
    // };

    onSelectionItemsChanged = (selectedRows) => {
        this.setState({ selectedRowsForfirstPOListOfVendors: selectedRows })
    }

    // addProduct = async () => {
    //     const selectedRows = this.state.selectedRowsForfirstPOList;
    //     const productMaterialTypeList = this.state.productObject.materialTypeList;
    //     let itemMap = new Map();

    //     for (const z of selectedRows) {
    //         const request = [
    //             z.idPurchaseOrder,
    //             this.state.purchaseObject.idMaterialInward,
    //             this.state.purchaseObject.updateStatus
    //         ];

    //         try {
    //             const response = await this.transactionStockServices.USP_Transaction_PurchaseOrderSelectbyID_PendingQty(request);
    //             if (response.statusCode === 200 && response.responseItem !== null) {
    //                 let selectedRowsForfirstPOListOfVendors = this.state.selectedRowsForfirstPOListOfVendors
    //                 const res = this.state.selectedRowsForfirstPOListOfVendors;

    //                 if (res.length > 0) {
    //                     for (const details of res) {
    //                         const key = `${details.idItem}_${details.itemDrawingNo}_${details.itemName}`;
    //                         const itemRate = Number(details.rate) || 0;
    //                         const qty = Number(details.recvQty) || 0;
    //                         const amt = Number(details.amount) || (itemRate * qty);
    //                         const taxableAmt = Number(details.taxableAmt) || 0;

    //                         const sgstAmt = Number(details.sgstAmt) || 0;
    //                         const cgstAmt = Number(details.cgstAmt) || 0;
    //                         const igstAmt = Number(details.igstAmt) || 0;

    //                         if (itemMap.has(key)) {
    //                             const existing = itemMap.get(key);
    //                             existing.quantity = (Number(existing.quantity) + qty).toFixed(2);
    //                             existing.amount = (Number(existing.amount) + amt).toFixed(2);
    //                             existing.discountAmt = (Number(existing.discountAmt) + Number(details.discountAmt) || 0).toFixed(2);
    //                             existing.chargesAmt = (Number(existing.chargesAmt) + Number(details.extraCharges) || 0).toFixed(2);
    //                             existing.total = (Number(existing.total) + taxableAmt).toFixed(2);
    //                             existing.sgstAmount = (Number(existing.sgstAmount) + sgstAmt).toFixed(2);
    //                             existing.cgstAmount = (Number(existing.cgstAmount) + cgstAmt).toFixed(2);
    //                             existing.igstAmount = (Number(existing.igstAmount) + igstAmt).toFixed(2);

    //                             existing.netTotal = (
    //                                 Number(existing.total) +
    //                                 Number(existing.sgstAmount) +
    //                                 Number(existing.cgstAmount) +
    //                                 Number(existing.igstAmount)
    //                             ).toFixed(2);
    //                         } else {
    //                             itemMap.set(key, {
    //                                 idPurchaseOrderItems: details.idPurchaseOrderItems,
    //                                 idPurchaseOrder: details.idPurchaseOrder,
    //                                 idMaterialPlanning: details.idMaterialPlanning || 0,
    //                                 idMaterialPlanningDetails: details.idMaterialPlanningDetails || 0,
    //                                 drawingNo: details.itemDrawingNo,
    //                                 materialType: details.itemItemType,
    //                                 idMaterialType: productMaterialTypeList.find(x => x.label === details.itemItemType)?.value,
    //                                 idItem: details.idItem,
    //                                 itemName: details.itemName,
    //                                 poQuantity: details.quantity,
    //                                 pendingQuantity: details.pendingQty,
    //                                 quantity: qty,
    //                                 poRate: Number(itemRate).toFixed(2),
    //                                 rate: Number(itemRate).toFixed(2),
    //                                 amount: Number(amt).toFixed(2),
    //                                 discount: Number(details.discount || 0).toFixed(2),
    //                                 discountAmt: Number(details.discountAmt || 0).toFixed(2),
    //                                 chargesAmt: Number(details.extraCharges || 0).toFixed(2),
    //                                 total: Number(taxableAmt).toFixed(2),
    //                                 sgst: Number(details.sgst || 0).toFixed(2),
    //                                 sgstAmount: sgstAmt,
    //                                 cgst: Number(details.cgst || 0).toFixed(2),
    //                                 cgstAmount: cgstAmt,
    //                                 igst: igstAmt > 0 ? Number(details.igst).toFixed(2) : 0,
    //                                 igstAmount: igstAmt,
    //                                 netTotal: Number(taxableAmt + sgstAmt + cgstAmt + igstAmt).toFixed(2),
    //                                 poAmount: Number(amt).toFixed(2),
    //                                 poTaxableAmt: Number(amt).toFixed(2),
    //                                 remarks: details.itemRemarks,
    //                                 idTaxGroup: details.idTaxGroup,
    //                                 idUnit: details.idUnit
    //                             });
    //                         }
    //                     }
    //                 }
    //             }
    //         } catch (error) {
    //             console.error("Error fetching pending PO items:", error);
    //         }
    //     }

    //     // Add existing state items (if needed)
    //     const oldItems = [...this.state.itemRowData];
    //     oldItems.forEach(item => {
    //         const key = `${item.idItem}_${item.drawingNo}_${item.itemName}`;
    //         if (!itemMap.has(key)) {
    //             itemMap.set(key, item);
    //         }
    //     });

    //     const finalItemList = Array.from(itemMap.values()).map((item, index) => ({
    //         ...item,
    //         keyId: index + 1
    //     }));

    //     this.setState({ itemRowData: finalItemList, open: false }, () => {
    //         this.finalCalculation();
    //     });
    // };

    addProduct = async () => {
        const selectedRows = this.state.selectedRowsForfirstPOListOfVendors;
        if (selectedRows.length > 0) {
            const grouped = selectedRows.reduce((acc, item) => {
                const key = `${item.idItem}_${item.drawingNo}_${item.itemName}_${item.discount}`;

                const itemDiscountAmt = (item.amount * item.discount) / 100;
                const chargesAmt = Number(item.extraCharges || 0);
                const taxableAmt = Number(item.taxableAmt || 0);
                const sgstAmount = Number(item.sgstAmt || 0);
                const cgstAmount = Number(item.cgstAmt || 0);
                const igstAmount = Number(item.igstAmt || 0);
                const pendingQuantity = Number(item.pendingQty || 0);

                if (!acc[key]) {
                    acc[key] = {
                        ...item,
                        materialType: item.itemItemType,
                        poRate: item.rate,
                        rate: item.rate,
                        discountAmt: itemDiscountAmt,
                        chargesAmt: chargesAmt,
                        total: taxableAmt,
                        sgstAmount: sgstAmount,
                        cgstAmount: cgstAmount,
                        igstAmount: igstAmount,
                        pendingQuantity: pendingQuantity,
                        poAmount: item.amount,
                        poQuantity: item.quantity,
                        poTaxableAmt: item.poTaxableAmt,
                        quantity: item.recvQty
                    };
                } else {
                    acc[key] = {
                        ...acc[key],
                        poQuantity: acc[key].quantity + item.quantity,
                        quantity: acc[key].recvQty + item.recvQty,
                        amount: acc[key].amount + item.amount,
                        poAmount: acc[key].amount + item.amount,
                        discount: acc[key].discount,
                        discountAmt: acc[key].discountAmt + itemDiscountAmt,
                        chargesAmt: acc[key].chargesAmt + chargesAmt,
                        total: acc[key].taxableAmt + taxableAmt,
                        sgstAmount: acc[key].sgstAmt + sgstAmount,
                        cgstAmount: acc[key].cgstAmt + cgstAmount,
                        igstAmount: acc[key].igstAmt + igstAmount,
                        pendingQuantity: acc[key].pendingQty + pendingQuantity,
                        poTaxableAmt: acc[key].poTaxableAmt + item.poTaxableAmt,
                        netTotal: acc[key].netTotal + item.netTotal,
                    };
                }
                return acc;
            }, {});

            const newItems = Object.values(grouped);

            const existingIds = new Set(
                this.state.itemRowData.map(item => item.idPurchaseOrderItems)
            );

            const itemsToAdd = newItems.filter(
                item => !existingIds.has(item.idPurchaseOrderItems)
            );

            this.setState((prevState) => ({
                itemRowData: [...prevState.itemRowData, ...itemsToAdd],
                open: false
            }), () => {
                this.finalCalculation();
            });
        } else {
            this.SwalServices.Error('Please select item')
        }
    };



    back = () => {
        this.setState({ open: false, selectedRowsForfirstPOList: [] });
    }

    handleOnClick = () => {
        this.setOpenModel2();
    }

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.productObject;
        data.idItem = event.data.idItem;
        data.itemIdLabel = event.data.itemName;
        this.setState({ itemObject: data, isSelectItemPopUp: !this.state.isSelectItemPopUp }, () => {
            this.getMasterItemSelectbyIDVendorwiseRate()
        });
    };

    generateMaterialPurchaseReport = () => {
        if (this.state.purchaseObject.idMaterialInward > 0) {
            let request = this.state.purchaseObject.idMaterialInward;
            this.transactionStockServices.generateMaterialPurchaseReport([request]).then((response) => {
                if (response.status == 200 && response !== null) {
                    var file = new Blob([response.data], { type: "application/pdf" });

                    var fileURL = URL.createObjectURL(file);

                    window.open(fileURL, "_blank");

                    this.setState({ isModalOpen: false });
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }


    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <>
                <div className='manual-invoice'>
                    <div className='data-display'>
                        <div className='data-display-inner relative'>
                            <ButtonGrp buttons={['add', 'print']}
                                onClickHandlers={{
                                    add: () => this.openPopUpForAddingItem(),
                                    // update: () => this.openPopUpForUpdateItem(),
                                    print: this.handlePrint,
                                }}
                            />
                            <MaterialPurchasePopup
                                isModalOpen={this.state.isModalOpen}
                                setOpenModel={this.setOpenModel.bind(this)}
                                purchaseObject={this.state.purchaseObject}
                                productObject={this.state.productObject}
                                handleChangeForWork={this.handleChangeForWork.bind(this)}
                                handleChangeForPayment={this.handleChangeForPayment.bind(this)}
                                handleChange={this.handleChange.bind(this)}
                                close={this.closePopup.bind(this)}
                                open={this.state.open}
                                addPO={this.addPO.bind(this)}
                                addProduct={this.addProduct.bind(this)}
                                back={this.back.bind(this)}
                                submit={this.submit.bind(this)}
                                isSaving={this.state.isSaving}
                                validState={this.state.validState}
                                itemRowData={this.state.itemRowData}
                                itemColdefs={this.state.itemColdefs}
                                firstPIList={this.state.firstPIList}
                                secondPIList={this.state.secondPIList}
                                thirdPIList={this.state.thirdPIList}
                                onFileChange={this.onFileChange.bind(this)}
                                getFiles={this.getFiles.bind(this)}
                                insertItem={this.insertItem.bind(this)}
                                clear={this.resetProductObject.bind(this)}
                                delete={this.handleDeleteItem.bind(this)}
                                handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                                handleChangeForDropdownForProductObject={this.handleChangeForDropdownForProductObject.bind(this)}
                                onItemRowDataClicked={this.onItemRowDataClicked.bind(this)}
                                handleCellClickfirstPIList={this.handleCellClickfirstPIList.bind(this)}
                                handleCellClickSecondPIList={this.handleCellClickSecondPIList.bind(this)}
                                onSelectionChanged={this.onSelectionChanged.bind(this)}
                                onSelectionItemsChanged={this.onSelectionItemsChanged.bind(this)}
                                handleOnClick={this.handleOnClick.bind(this)}
                                generateMaterialPurchaseReport={this.generateMaterialPurchaseReport.bind(this)}
                            />
                            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Material purchase</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.rowData}
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.colDefs}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onRowDoubleClicked={this.onRowDoubleClicked}
                                        // onGridReady={this.onGridReady}
                                        overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                        overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                        onCellClicked={this.handleCellClick}
                                    />
                                </div>
                            </div>

                            <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                    <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.table2Data}
                                        columnDefs={this.state.table2ColDefs}
                                        rowHeight={this.state.rowHeight}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onGridReady={this.onGridReady}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.productObject.itemList}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    //handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                //receiptDetails={this.state.receiptDetails}handleSelectChange
                />
            </>
        )
    }
}
